import { ToastProvider } from "/utils/toast-context.jsx";

export default function Layout({ children }) {
  return (
    <ToastProvider>
      {children}
    </ToastProvider>
  );
}
